module.exports = __webpack_public_path__ + "static/wshilogo-d64faa04065a0eee1f5b4c4cc6fdaa8e.png";